import usePlans from 'components/profile/usePlans';
import OwnerSummary from 'components/account/OwnerSummary';
import AccountGrid, {
  LeadingArea,
  WideContentArea,
} from 'components/account/AccountLayout';
import PlanList from 'components/account/AccountPlanList';
import AccountDivider from 'components/account/AccountDivider';
import { CreateTeamButton } from 'components/account/AccountActions';
import { UserHeader } from 'components/account/TeamNav';

export default function SettingsPage() {
  const { proUserPlans, teamPlans } = usePlans();
  return (
    <AccountGrid navTitle="Account" tabTitle="Account">
      <UserHeader />
      <OwnerSummary />
      <AccountDivider />
      {proUserPlans.length > 0 && (
        <>
          <LeadingArea>
            <h2>Pro Plan</h2>
          </LeadingArea>
          <WideContentArea>
            <PlanList items={proUserPlans} />
          </WideContentArea>
          <AccountDivider />
        </>
      )}
      <LeadingArea>
        <h2>{'Workspaces'}</h2>
        <CreateTeamButton />
      </LeadingArea>
      <WideContentArea>
        <PlanList items={teamPlans} />
      </WideContentArea>
    </AccountGrid>
  );
}
